import { useQuery } from '@tanstack/react-query';
import { spreadsAPI } from '../api/spreads';
import { useAuthStore } from '../store/authStore';
import { authAPI } from '../api/auth';

export const useSpreads = () => {
  return useQuery({
    queryKey: ['spreads'],
    queryFn: () => spreadsAPI.getSpreads(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useLastSpreadKey = () => {
  const user = useAuthStore(s => s.user);
  return (user?.preferences as any)?.lastSpreadKey as string | undefined;
};

export const useSaveLastSpreadKey = () => {
  return (spreadKey: string) => {
    // Save to localStorage only (non-critical preference)
    // This avoids unnecessary API calls and works offline
    localStorage.setItem('lastSpreadKey', spreadKey);
  };
};
